import React from "react";
import "../css/ContentPage.css";
import short_loan from "../images/short_loan.jpg";
import { Link } from "react-router-dom";
import ChatButton from "../components/ChatButton";

const ShortLoan = () => {
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>First-Time Borrower Loan</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              {/* <div className="content_banner">
                <img src={short_loan} alt="" />
              </div> */}
              <h1 className="page_title mt30 mb20">First-Time Borrower Loan</h1>
              <p>First-Time Borrower Loan is a type of unsecured personal loan specifically designed for those young professionals/recently employed individuals who have never taken a loan before. Such individuals are also commonly called new-to-credit (NTC) borrowers. They have no previous credit history or credit score. So, their credit report reflects a "NA/NH" remark, showcasing a lack of previous data. Unfortunately, banks may not offer a loan to NTC borrowers due to credit risk.</p>

              <p>However, CreduMoney, a highly reputable and trusted digital lending platform in India, offers a First-Time Borrower Loan so that new borrowers can access funds when needed and build their credit history in parallely. You can apply for small-ticket personal loans, such as ₹5000, ₹10,000, ₹15,000, ₹20,000, ₹25,000, ₹30,000, ₹50,000, etc, that best suit your repayment capacity and get access to funds seamlessly and swiftly.</p>

              <p>Unlike other lending platforms, which may ask for additional income proof/papers or may charge a higher rate of interest, CreduMoney, being your dependable loan partner, asks you to submit very few basic documents, such as PAN, Aadhar and Bank Statement and charges the same rate of interest, making borrowing easy and stress-free. Remember, we not only provide the first loan of your life but also aim to open doors to higher-value loans for you in future.</p>
              <div className="button_container flex justify-center">
                <Link to="/apply-now">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default ShortLoan;
